/* Loaded independently of cart eligibility so Ajax-inserted reminders work. */
if (!customElements.get('fotric-cart-code-reminder')) {
  customElements.define('fotric-cart-code-reminder', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelector('[data-copy-code]')?.addEventListener('click', () => this.copyCode(), {signal:this.abort.signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
    async copyCode() {
      if (this.copying) return;
      this.copying = true;
      const field = this.querySelector('[data-offer-code]');
      const button = this.querySelector('[data-copy-code]');
      const status = this.querySelector('[data-copy-status]');
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(field.value);
          copied = true;
        }
      } catch { /* Offer a selected code if clipboard permission is unavailable. */ }
      if (!copied && this.isConnected) {
        field.focus();
        field.select();
        field.setSelectionRange(0, field.value.length);
        try { copied = Boolean(document.execCommand('copy')); } catch { /* Manual copy remains available. */ }
      }
      if (this.isConnected) {
        button.textContent = copied ? 'Copied!' : 'Copy code';
        status.textContent = copied ? 'Enter TP320AOFF in the discount code field at checkout.' : 'Select and copy TP320AOFF, then enter it at checkout.';
        if (copied) button.focus({preventScroll:true});
      }
      this.copying = false;
    }
  });
}
